import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { IQuoteState, QuoteState } from '@nibtravel/shared/data-access/quote';

@Injectable()
export class QqcSelector {
  @Selector([QuoteState])
  static quoteStage(quote: IQuoteState) {
    return quote.stage;
  }

  @Selector([QuoteState])
  static currentRoute(quote: IQuoteState) {
    return quote.currentRoute;
  }

  @Selector([QuoteState])
  static isHomeAddressDirty(quote: IQuoteState): boolean {
    const homeAddress = { ...quote.input.homeAddress };
    // This is the only prop that needs to be populated;
    delete homeAddress.countryCode;
    return Object.values(homeAddress).some((value) => !!value);
  }
}
